<template>
  <div class="content-15">
    <div class="content-15__title"><span class="content-15__title__text">预测图库</span></div>
    <div class="content-15__search">
      <div
        v-for="(lottery, index) in lotteryMapping"
        :key="index"
        class="content-15__search__item"
        :class="{ 'active': activedTab === lottery.val }"
        @click="changeLottery(lottery.val)"
      >
        <span class="content-15__search__item__text">{{ lottery.name }}</span>
      </div>
    </div>
    <transition name="layout" mode="out-in">
      <div :key="latestData.imgURL" class="content-15__content">
        <template v-if="latestData && Object.keys(latestData).length">
          <div class="content-15__content__imgbox" style="min-height: 224px;">
            <img :src="latestData.imgURL" @click="goToTuku">
          </div>
          <div class="content-15__content__imgname">
            <span class="content-15__content__imgname__text">第 {{ latestData.period }} 期</span>
          </div>
        </template>
        <div v-else class="no-image">无资料</div>
      </div>
    </transition>
  </div>
</template>

<script>
import { getTukus } from '@/api/desktop/images'

export default {
  name: 'PredictionTuku',
  data() {
    return {
      activedTab: 'ff6',
      latestData: {
        period: '',
        imgURL: ''
      },
      showLotteryList: ['ff6', 'sf6', 'js6', 'amff6', 'amsf6', 'amwf6']
    }
  },
  computed: {
    // 從 store 取各彩種的圖庫 ID
    tukuCategory() {
      return this.$store.state.app.tuku
    },
    lotteryMapping() {
      const cpDetail = this.$store.state.lottery.cpsDetail
      const newMap = this.showLotteryList.map(item => {
        return {
          name: cpDetail[item]?.name || '',
          val: item
        }
      })
      return newMap
    }
  },
  mounted() {
    const categoryID = this.tukuCategory[this.activedTab] && this.tukuCategory[this.activedTab].categoryIDs
    const params = {
      categoryID: categoryID?.[0] || null,
      count: 1
    }
    this.getTukus(params)
  },
  methods: {
    changeLottery(lotteryCode) {
      this.activedTab = lotteryCode

      const categoryID = this.tukuCategory[lotteryCode] && this.tukuCategory[lotteryCode].categoryIDs
      const params = {
        categoryID: categoryID?.[0] || null,
        count: 1
      }
      this.getTukus(params)
    },
    async getTukus(query) {
      if (query) {
        const [data, err] = await getTukus(query)
        if (err) {
          console.error(`[error]:`, err)
          return
        }
        this.latestData = data[0] || {}
      }
    },
    goToTuku() {
      this.$router.push({ path: `/images?lotteryCode=${this.activedTab}` })
    }
  }
}
</script>

<style lang="scss" scoped>
.content-15__content__imgbox {
  min-height: 224px;
  img {
    min-height: 224px;
    height: 224px;
    object-fit: contain;
    object-position: center;
    width: 100%;
  }
  &:hover {
    cursor: pointer;
  }
}
.no-image {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 250px;
  font-size: 14px;
  padding: 12px;
  color: #666666;
}
</style>
